import { render, staticRenderFns } from "./boothStatisticsList.vue?vue&type=template&id=6c4d7cc4&scoped=true"
import script from "./boothStatisticsList.vue?vue&type=script&lang=js"
export * from "./boothStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./boothStatisticsList.vue?vue&type=style&index=0&id=6c4d7cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d7cc4",
  null
  
)

export default component.exports